import { useParams } from "react-router"
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import RenderSetting from '../contenttype/settings/RenderSetting'
import RelationList from '../RelationList'
import SchedulePublish from './SchedulePublish'

const EditContentType = ({language, setBreadcrumbObject}) => {
    let { contentTypeId } = useParams();
    const [publishDate, setPublishDate] = useState()
    const [scheduleDate, setScheduleDate] = useState()
    const [showSchedulePublish, setShowSchedulePublish] = useState(false)
    const [contentType, setContentType] = useState()
    const [isDraft, setIsDraft] = useState(false)
    const [lastSaved, setLastSaved] = useState()
    const [savedAlert, setSavedAlert] = useState()

    const fetchContentType = async () => {

        var graphql = JSON.stringify({
            query: `query {
                        contentType(id:"${contentTypeId}") {
                            id
                            contentTypeId 
                            contentTypeName
                            published
                            publishDate
                            scheduleDate

                            settings{
                                id
                                settingAlias
                                settingName
                                settingType
                                defaultValue
                                settingDescription
                                showDescription
                            }
                            values{
                                id
                                settingId
                                contentPublished
                                contentDraft
                                relations{
                                    id
                                    contentTypeName
                                }
                            }
                            contentModel{
                                id
                                modelName
                            }
                            relations{
                                id
                                contentTypeName
                            }
                            editors{
                                id
                                editorName
                                editorEmail
                            }
                        }
                    }`,
            variables: {}
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {return JSON.parse(result).data})
        .catch(error => console.log('error', error))
        const data = await res
        return data

    }

    
    useEffect(() => {
        const getContentType = async () => {
            const data = await fetchContentType()
            setContentType(data.contentType)
            /*
            setBreadcrumbObject({type: language.value === "DA" ? "Artikel: " : "Article: ", name:data.contentType.contentTypeName, link: `/settings/contentModels/${data.contentType.contentModel.id}`, linkText: data.contentType.contentModel.modelName})
            if(data.contentType.published){
                var d = new Date(data.contentType.publishDate)
                setPublishDate(d.toLocaleString())
            }
            if(data.contentType.scheduleDate !== "1970-01-01T00:00:00"){
                var d = new Date(data.contentType.scheduleDate)
                setScheduleDate(d)
            }
            */
        }
        getContentType()

    },[contentTypeId, language])

    useEffect(()=>{
        if(contentType){
            setBreadcrumbObject({type: language.value === "DA" ? "Artikel: " : "Article: ", name:contentType.contentTypeName, link: `/control/contentModels/${contentType.contentModel.id}`, linkText: contentType.contentModel.modelName})
            if(contentType.published){
                var d = new Date(contentType.publishDate)
                setPublishDate(d.toLocaleString())
            }
            if(contentType.scheduleDate !== "1970-01-01T00:00:00"){
                var d = new Date(contentType.scheduleDate)
                setScheduleDate(d)
            }
        }
    },[contentType])

    useEffect(() => {
        const handleLastSaved = async () => {
            setSavedAlert('saved')
            setTimeout(() => {
                setSavedAlert('')
            }, 2000);
        }
        handleLastSaved()

    },[lastSaved])

    
    const publishChanges = async e => {
        var graphql = JSON.stringify({
            query: `mutation($contentTypeId: Guid) {
                        publishContentType(contentTypeId:$contentTypeId) {
                            id
                            publishDate
                        }
                    }`,
            variables: {
                "contentTypeId": contentTypeId}
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {return JSON.parse(result).data})
        .catch(error => console.log('error', error))
        const data = await res
        setIsDraft(false)
        var d = new Date(data.publishContentType.publishDate)
        setPublishDate(d.toLocaleString())
        return data
    }    
    
    const unPublish = async e => {
        var graphql = JSON.stringify({
            query: `mutation($contentTypeId: Guid) {
                        unPublishContentType(contentTypeId:$contentTypeId) {
                            id
                        }
                    }`,
            variables: {
                "contentTypeId": contentTypeId}
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {return JSON.parse(result).data})
        .catch(error => console.log('error', error))
        const data = await res
        setIsDraft(true)
        setPublishDate()
        return data
    }
     
    
    const unSchedule = async e => {
        var graphql = JSON.stringify({
            query: `mutation($contentTypeId: Guid, $scheduleDate: DateTime) {
                        schedulePublishContentType(contentTypeId:$contentTypeId, scheduleDate:$scheduleDate) {
                            id
                        }
                    }`,
            variables: {
                "contentTypeId": contentTypeId
                ,"scheduleDate": "1970-01-01T00:00:00.000"
            }
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {return JSON.parse(result).data})
        .catch(error => console.log('error', error))
        const data = await res
        setScheduleDate()
        return data
    }

    const clearDraft = async e => {
        var graphql = JSON.stringify({
            query: `mutation($contentTypeId: Guid) {
                        clearDraftContentType(contentTypeId:$contentTypeId) {
                            id
                            contentTypeId 
                            contentTypeName
                            published
                            publishDate
                            scheduleDate

                            settings{
                                id
                                settingAlias
                                settingName
                                settingType
                                defaultValue
                                settingDescription
                                showDescription
                            }
                            values{
                                id
                                settingId
                                contentPublished
                                contentDraft
                                relations{
                                    id
                                    contentTypeName
                                }
                            }
                            contentModel{
                                id
                                modelName
                            }
                            relations{
                                id
                                contentTypeName
                            }
                            editors{
                                id
                                editorName
                                editorEmail
                            }
                        }
                    }`,
            variables: {
                "contentTypeId": contentTypeId}
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {
            setContentType()
            return JSON.parse(result).data
        })
        .catch(error => console.log('error', error))
        const data = await res
        if(data.clearDraftContentType){
            setIsDraft(false)
            setScheduleDate()
            setLastSaved()
            setContentType(data.clearDraftContentType)
        }
        return data
    }

    let content;

    if (contentType) {
        content = (
            <div id="cc_value_editcontainer">
                <div id="cc_value_list" className="scrollable cc_item_list">
                {
                    contentType.settings.map((setting) => (
                        <RenderSetting key={setting.id} 
                                    contentTypeId={contentType.id} 
                                    setting={setting} 
                                    value={contentType.values.filter((value)=>value.settingId === setting.id)[0]}  
                                    setIsDraft={setIsDraft}
                                    setLastSaved={setLastSaved}/>
                    ))
                }
                </div>
                <div id="cc_info_panel" className="scrollable">
                    {(lastSaved) && 
                    <div className={`cc-info-box ${savedAlert}`}>
                        <b>{language.value === "DA" ? "Sidst gemt" : "Last saved"}:</b> {lastSaved.toLocaleString()}
                    </div>
                    }
                    {
                        (isDraft) && 
                        <>
                        <div className="cc_article_publish_btns">
                            <button onClick={publishChanges} className={`cc-btn green-gradient`}>{language.value === 'DA' ? 'Offentliggør' : 'Publish'}</button>
                            <button onClick={()=>setShowSchedulePublish(showSchedulePublish ? false : true)} className={`cc-btn blue-gradient`}>{language.value === 'DA' ? 'Planlæg offentliggørelse' : 'Schedule publish'}</button>
                            <button onClick={clearDraft} className={`cc-btn red-gradient`}>{language.value === 'DA' ? 'Fortryd ikke offentliggjorte ændringer' : 'Cancel unpublished changes'}</button>
                        </div>
                        </>
                    }
                    {
                        (publishDate) && <>
                        <div className="cc-info-box">
                            <span><b>{language.value === "DA" ? "Offentliggjort" : "Published"}:</b> {publishDate}</span>
                            <span onClick={unPublish} className="txt-link">{language.value === "DA" ? "Fjern offentliggørelse" : "Unpublish"}</span>
                        </div>
                        </>
                    }
                    {
                        (scheduleDate) && 
                        <div className="cc-info-box">
                            <span><b>{language.value === "DA" ? "Planlagt offentliggørelse" : "Scheduled publish"}:</b> {scheduleDate.toLocaleString()}</span>
                            <span onClick={unSchedule} className="txt-link">{language.value === "DA" ? "Fjern planlagt offentliggørelse" : "Remove scheduled publish"}</span>
                        </div>
                    }
                    <RelationList contentTypes={contentType.relations} language={language} heading={language.value === "DA" ? "Vises i disse Artikler" : "Shown in these Articles"} />
                    {
                        (contentType.editors) && 
                        <> 
                        <h3>{language.value === "DA" ? "Redaktører" : "Editors"}</h3>
                        {
                        contentType.editors.map((editor) => (
                            <div>
                                <span>{editor.editorName}</span>  
                            </div>
                        ))
                        }
                        </>
                    }
                </div>
                <SchedulePublish language={language} contentTypeId={contentTypeId} scheduleDate={scheduleDate} setScheduleDate={setScheduleDate} showSchedulePublish={showSchedulePublish} setShowSchedulePublish={setShowSchedulePublish}/>
            </div>
        );
      }

    return (
        <>
            {content}
        </>
    )
}

export default EditContentType
